//Custo css import (removed as it's now shared in ServiceForm)

//Boostrap import
import { BiEdit } from 'react-icons/bi';

//React import
import ModalBtn from '../../molecules/modalButton/view';

import { updateService } from '../../../usecases/service-usecase';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { mapServiceToApi } from '../../../infrastructure/mappers/service-mapper';
import React from 'react';
import ServiceForm from '../ServiceForm/view';

const EditService = ({ data, hidden = false, profile }) => {
    const submitId = "edit-service-" + data?.id;

    const onSubmit = (formData) => {
        const payload = mapServiceToApi(formData, 'edit');
        updateService(data.id, payload).then((res) => {
            dispatchCustomEvent("reload-services", res);
            dispatchCustomEvent("service-edited", {});
            dispatchCustomEvent("popup", { message: "Cambios guardados" });
            dispatchCustomEvent("loading-btn-" + submitId, null);
            dispatchCustomEvent("close-edit-service-" + data.id + "-modal", []);
        }).catch((error) => {
            dispatchCustomEvent("loading-btn-" + submitId, null);
            const err = error.response?.data?.message;
            const messages = {
                "limit_reached": "Ups, alcanzaste tu límite de servicios, aumenta tu plan y remueve todos los límites...",
                "service_exist": "Existe un servicio con el mismo SKU.",
                "sku_empty": "El SKU no puede estar vacío.",
                "name_empty": "El nombre no puede estar vacío.",
                "value_empty": "El valor del servicio no puede estar vacío.",
                "value_invalid": "Valor del servicio no válido.",
            };
            if (err && messages[err]) {
                dispatchCustomEvent("popup", { message: messages[err], type: "error" });
            } else {
                dispatchCustomEvent("popup", { message: "Ocurrió un error al guardar los cambios", type: "error" });
            }
        });
    };

    return (
        <ModalBtn
            id={"edit-service-" + data?.id}
            title={<BiEdit></BiEdit>}
            type="action"
            hidden={hidden}
        >
            <ServiceForm
                mode="edit"
                initialData={data}
                onSubmit={onSubmit}
                submitId={submitId}
            />
        </ModalBtn>
    );
};

export default EditService
